export const SITE_URL = 'https://globaledu.live';
export const SITE_NAME = 'Global Educational Consultants';
export const DEFAULT_OG_IMAGE = '/assets/optimized/gec-hero-foreground.webp';

export const absoluteUrl = (path = '/') => {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const siteOrganizationSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'EducationalOrganization',
      '@id': `${SITE_URL}/#organization`,
      name: SITE_NAME,
      alternateName: 'GEC Educational Consultancy',
      url: SITE_URL,
      logo: absoluteUrl('/assets/optimized/gec-logo.webp'),
      image: absoluteUrl(DEFAULT_OG_IMAGE),
      description: 'Study abroad counselling, university selection, admissions and visa guidance for students in India.',
      foundingDate: '1993',
      telephone: '+91-9020-500-700',
      email: 'info@globaledu.in',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Metro Pillar 595, II Floor, Penta Towers, Adj. Kaloor Metro Station',
        addressLocality: 'Kochi',
        addressRegion: 'Kerala',
        postalCode: '682017',
        addressCountry: 'IN',
      },
      areaServed: [
        { '@type': 'City', name: 'Kochi' },
        { '@type': 'State', name: 'Kerala' },
        { '@type': 'Country', name: 'India' },
      ],
      knowsAbout: [
        'Study abroad counselling',
        'International university admissions',
        'Student visa guidance',
        'Scholarship assistance',
        'Australia study options',
        'Canada study options',
        'Ireland study options',
        'New Zealand study options',
        'United Kingdom study options',
        'United States study options',
      ],
      sameAs: [
        'https://wa.me/919020500700',
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+91-9020-500-700',
        email: 'info@globaledu.in',
        contactType: 'customer service',
        areaServed: 'IN',
        availableLanguage: ['English', 'Malayalam'],
      },
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: SITE_NAME,
      publisher: { '@id': `${SITE_URL}/#organization` },
      inLanguage: 'en-IN',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_URL}/courses?search={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
  ],
};

export const setStructuredData = (id: string, schema: unknown) => {
  if (typeof document === 'undefined') return;
  let script = document.getElementById(id) as HTMLScriptElement | null;
  if (!schema) {
    script?.remove();
    return;
  }
  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(schema);
};

export const breadcrumbSchema = (items: Array<{ name: string; path: string }>) => ({
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: absoluteUrl(item.path),
  })),
});
